/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The block explorer API
 * The block explorer API
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import { customAxiosInstanceV2 } from '../utils/axios';
import type { ErrorType } from '../utils/axios';
export interface AccountDetail {
  address: string;
  balance: string;
  byteCode: string;
  contractCreator: string;
  deploymentTransaction: string;
}




type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Get account detail.
 */
export const getAccountByHash = (
    hash: string,
 options?: SecondParameter<typeof customAxiosInstanceV2>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstanceV2<AccountDetail>(
      {url: `/accounts/${hash}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAccountByHashQueryKey = (hash: string,) => {
    return [`/accounts/${hash}`] as const;
    }

    
export const getGetAccountByHashQueryOptions = <TData = Awaited<ReturnType<typeof getAccountByHash>>, TError = ErrorType<unknown>>(hash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountByHash>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstanceV2>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountByHashQueryKey(hash);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountByHash>>> = ({ signal }) => getAccountByHash(hash, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(hash), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountByHash>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountByHashQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountByHash>>>
export type GetAccountByHashQueryError = ErrorType<unknown>

export const useGetAccountByHash = <TData = Awaited<ReturnType<typeof getAccountByHash>>, TError = ErrorType<unknown>>(
 hash: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountByHash>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstanceV2>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountByHashQueryOptions(hash,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




